module.exports = __webpack_public_path__ + "static/media/pltlogo-white.99501ee7.webp";